<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">
				<template v-if="auxiliary">{{auxiliary.name}}</template><template v-if="auxiliaryItem">:{{auxiliaryItem.name}}</template> 明细账</span>
			<span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
		</div>
		<Row type="flex" :space-x="10" class="margin-right-left margin-top">
			<Cell>
				<account-date-choose v-model="accountDate"/>
			</Cell>
			<Cell class="label">辅助类别：</Cell>
			<Cell>
				<Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType" keyName="id" titleName="name"/>
			</Cell>
			<Cell>
				<Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch">查询</Button>
			</Cell>
			<Cell :flex="1">
				<!--<div class="float-right">
					<Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
				</div>-->
			</Cell>
		</Row>
		<Row class="h-panel-body" type="flex" :space-x="10">
			<Cell :flex="1">
				<Table :datas="dataList" :border="true" :loading="loading">
					<TableItem title="日期" prop="voucherDate" :width="85"></TableItem>
					<TableItem title="凭证字号" :width="85">
						<template slot-scope="{data}" v-if="data.word">
							<router-link :to="{name:'VoucherForm',params:{voucherId:data.voucherId}}">{{data.word}}-{{data.code}}</router-link>
						</template>
					</TableItem>
					<TableItem title="摘要" prop="summary"></TableItem>
					<TableItem title="借方" align="right" :width="85">
						<template slot-scope="{data}">
							{{data.debitAmount|numFormat}}
						</template>
					</TableItem>
					<TableItem title="贷方" align="right" :width="85">
						<template slot-scope="{data}">
							{{data.creditAmount|numFormat}}
						</template>
					</TableItem>
					<TableItem title="方向" prop="balanceDirection" align="center" :width="50"></TableItem>
					<TableItem title="余额" align="right" :width="85">
						<template slot-scope="{data}">
							{{data.balance|numFormat}}
						</template>
					</TableItem>
				</Table>
			</Cell>
			<Cell v-width="200">
				<Tree @select="doSelect" :option="param" ref="auxiliary" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
			</Cell>
		</Row>
	</app-content>
</template>

<script>
/**
 * 辅助核算明细账
 */
	export default {
		name: "AuxiliaryAccountingDetail",
		data() {
			return {
        // 凭证列表数据
				dataList: [],
				loading: false,
				showNumPrice: false,
				param: {
					keyName: 'id',
					parentName: 'parentId',
					titleName: 'name',
					dataMode: 'list',
					datas: []
				},
				accountDate: null,
        // 选中的辅助类别（如"部门"）
				auxiliary: null,
        // 选中的辅助项目（如具体某门店、某往来等）
				auxiliaryItem: null,
        // 辅助类别列表数据，部门或往来
				auxiliaryType: []
			}
		},
		methods: {
			loadAuxiliaryType() {
				this.$api.setting.accountingCategory.list().then(({data}) => {
					this.auxiliaryType = data;
          // console.log("auxiliaryType："+JSON.stringify(this.auxiliaryType))
				});
			},
      /**
       * 加载辅助列表数据
       * @description 根据辅助ID加载相关的辅助列表数据，处理数据格式并初始化相关状态
       * @returns {void}
       */
      loadAuxiliaryList() {
        // 清空数据列表
        this.dataList = [];
        // 调用API加载辅助列表数据
        this.$api.accountbook.loadAuxiliaryList({
          auxiliaryId: this.auxiliary.id
        }).then(({data}) => {
          // 格式化数据显示名称（编码+名称）
          data.forEach(val => val.name = val.code + " " + val.name);
          // 按编码进行排序
          data = data.sort((a, b) => a.code.localeCompare(b.code));
          // 设置参数中的数据源
          this.$set(this.param, "datas", data);
          // 如果存在数据，则设置默认选中项并加载列表
          if (data.length) {
            this.auxiliaryItem = data[0];
            this.loadList();
            // 在下次DOM更新后更新选择器的选中状态
            this.$nextTick(() => {
              this.$refs.auxiliary.updateSelect(this.auxiliaryItem.id);
            });
          }
        });
      },
			loadList() {
				this.loading = true;
				this.$api.accountbook.loadAuxiliaryDetails({
					accountDate: this.accountDate,
					auxiliaryId: this.auxiliary.id,
					auxiliaryItemId: this.auxiliaryItem.id,
				}).then(({data}) => {
					this.dataList = data;
				}).finally(() => {
					this.loading = false;
				});
        // console.log("部门往来信息："+JSON.stringify(this.dataList))
			},

			doSearch() {
				this.loadAuxiliaryList();
			},
			doSelect(node) {
				this.auxiliaryItem = node;
				this.loadList();
			}
		},
		mounted() {
			this.loadAuxiliaryType();
		}
	}
</script>

<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center; /* 垂直居中对齐 */
}
</style>